<template>
  <div>
    <lottie
      v-if="type === 'brain'"
      :options="defaultOptions"
      :height="340"
      :width="260"
      v-on:animCreated="handleAnimation"
    />
    <div
      v-else-if="type === 'circle'"
      :class="
        `bg-loader ${this.dark && 'bg-loader--dark'} ${this.contentLoader &&
          'bg-loader--content'}`
      "
    ></div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import Lottie from "vue-lottie";
import * as animationData from "./brain.json";
import BgIcon from "../bg-icon";

export default {
  name: "bg-loader",
  components: {
    Lottie,
    BgIcon,
  },
  props: {
    contentLoader: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "brain",
    },
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    stop: function() {
      this.anim.stop();
    },
    play: function() {
      this.anim.play();
    },
    pause: function() {
      this.anim.pause();
    },
    onSpeedChange: function() {
      this.anim.setSpeed(this.animationSpeed);
    },
  },
};
</script>
